var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ContentBox,[_c(_setup.Empty,{attrs:{"title":"~ 404 ~","desc":"该页面不存在"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }